import {AxiosError} from 'axios'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useLocation, useNavigate} from 'react-router-dom'
import {listDeviceByTypes} from '../../modules/auth/core/_requests'
import DeviceTypesDeletionModal from './Modals/DeviceTypesModal/DeviceTypesDeletionModal'
import TypeTabContentBar from './TabContentBars/TypeTabContentBar'
import TypeTabContentTable from './TabContentTables/TypeTabContentTable'

function SelectedDeviceType({id}: any) {
  const navigate = useNavigate()
  const intl = useIntl()
  const {state}: any = useLocation()
  const page = state?.page || 1
  const rowsPerPage = state?.rowsPerPage || 5
  const {row: item}: any = state

  const [deviceTypeList, setDeviceTypeList] = useState([])
  const [isChecked, setISChecked] = useState<Array<string>>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [action, setAction] = useState(true)
  const [delAction, setDelAction] = useState(false)

  useEffect(() => {
    if (action) {
      getList()
      setAction(false)
    }
  }, [action])

  const getList = async () => {
    try {
      const {data} = await listDeviceByTypes(0, id)
      setDeviceTypeList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const keys = ['thingName']

  const search = (list: any) => {
    if (searchTerm) {
      return list.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
      )
    } else {
      return deviceTypeList
    }
  }

  function handleChecked(e: any) {
    const {value, checked}: any = e.target
    if (checked) {
      setISChecked([...isChecked, value])
    } else {
      setISChecked(isChecked.filter((item: any) => item !== value))
    }
  }

  function checkedControl(id: string) {
    if (isChecked) {
      if (isChecked.includes(id)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  if (delAction) {
    navigate('/management/all-device/device-types', {
      state: {page, rowsPerPage},
    })
  }

  return (
    <div className=' gx-xl-10 mt-lg-n16 mt-2'>
      <button
        type='button'
        className='btn btn-light mb-2 '
        onClick={() =>
          /*navigate(-1)*/ navigate('/management/all-device/device-types', {
            state: {page, rowsPerPage},
          })
        }
      >
        ❮ {intl.formatMessage({id: 'BACK'})}
      </button>
      <div className='d-flex justify-content-between'>
        <h2 className='ms-2'>{item.name}</h2>
        <div className='flex-row'>
          <button
            type='button'
            className='btn btn-light square border border-dark m-2'
            data-bs-toggle='modal'
            data-bs-target='#deleteType_modal'
          >
            Delete
          </button>
        </div>
      </div>
      <div className='card card-custom'>
        <div className='card-header text-dark'>
          <h2 className='card-title '>Device Type Details</h2>
          <div className='card-toolbar'></div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-row flex-column-fluid'>
            <div className='d-flex flex-row-fluid'>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50'>Name</span>
                    <span className='text-dark'>{item.name}</span>
                  </div>
                </div>

                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50 mt-5'>Status</span>
                    <span className='text-black'>
                      {item.isActive === true ? (
                        <div className='text-success'>
                          <i className='fas fa-circle-check text-success me-2' />
                          Active
                        </div>
                      ) : (
                        <div className='text-danger'>
                          <i className='fas la-exclamation-circle text-danger me-2' />
                          Not Active
                        </div>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className='separator my-10'></div>

            <div className='d-flex flex-row-fluid   '>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50'> Description</span>
                    <span className='text-dark'>{item.description}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* */}

      <div className='card card-custom shadow mt-10'>
        <div className='card-header card-header-stretch'>
          <div className='card-toolbar'>
            <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
              <li className='nav-item'>
                <a className='nav-link active' data-bs-toggle='tab' href='#kt_tab_pane_7'>
                  Device Type
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='card-body'>
          <div className='tab-content' id='myTabContent'>
            <div className='tab-pane  active' id='kt_tab_pane_7' role='tabpanel'>
              <TypeTabContentBar
                title='Device Type'
                cBTitle='Type'
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setAction={setAction}
              />
              <div className='separator border-3 my-10'></div>
              <TypeTabContentTable
                search={search}
                deviceGroupList={deviceTypeList}
                checkedControl={checkedControl}
                handleChecked={handleChecked}
                isAction={action}
              />
            </div>
          </div>
        </div>
      </div>
      {/* */}
      <DeviceTypesDeletionModal checkList={item.id} setAction={setDelAction} />
    </div>
  )
}

export default SelectedDeviceType
